import {routeParamId} from "./constants";

export class PathHelper {
    static buildPathWithId(path: string, id: number | string): string {
        return path.replace(routeParamId, `/${id}`);
    };
}
